import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";

export const ScheduleTeaser = () => (
  <section className="py-24 md:py-32" data-testid="home-schedule-teaser">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="relative overflow-hidden rounded-2xl border border-white/10 lg:col-span-7">
        <img src="/images/camp.jpg" alt="Tenda di bawah langit berbintang" loading="lazy" className="aspect-[16/11] w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/70 to-transparent" />
      </div>
      <div className="lg:col-span-5">
        <p className="overline-label">Jadwal</p>
        <h2 className="mt-4 font-display text-4xl font-light leading-tight sm:text-5xl">
          Lihat tanggal yang <em className="text-gold">masih kosong.</em>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-neutral-400">
          Kalender kami menampilkan semua tanggal — mana yang sudah dibooking dan mana yang masih tersedia — supaya kamu bisa
          merencanakan pendakian tanpa bolak-balik bertanya.
        </p>
        <Link to="/jadwal" className="btn-gold mt-10" data-testid="teaser-btn-schedule">
          <CalendarDays className="h-4 w-4" /> Buka Kalender
        </Link>
      </div>
    </div>
  </section>
);
